var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M21.7175 9.07615C23.3172 7.47645 23.3172 4.88283 21.7175 3.28315C20.1178 1.68345 17.5241 1.68345 15.9244 3.28315L15.0005 4.20715C15.0131 4.24536 15.0262 4.28409 15.0399 4.32332C15.3785 5.29952 16.0176 6.57922 17.2197 7.78131C18.4217 8.98341 19.7014 9.62243 20.6777 9.96111C20.7167 9.97466 20.7553 9.98772 20.7933 10.0003L21.7175 9.07615Z",
    fill: "#7D7D7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0402 4.16675L15.0005 4.20653C15.0131 4.24474 15.0262 4.28348 15.0398 4.32272C15.3785 5.2989 16.0175 6.5786 17.2196 7.78071C18.4217 8.9828 19.7014 9.62181 20.6776 9.96049C20.7163 9.97392 20.7545 9.98688 20.7923 9.99938L11.8751 18.9165C11.274 19.5177 10.9733 19.8183 10.6419 20.0769C10.2509 20.3819 9.82784 20.6433 9.38023 20.8566C9.00077 21.0375 8.59745 21.1719 7.79085 21.4407L3.53737 22.8586C3.14044 22.9909 2.70281 22.8876 2.40695 22.5917C2.11108 22.2958 2.00778 21.8582 2.14009 21.4613L3.55791 17.2078C3.82679 16.4012 3.96122 15.9979 4.14206 15.6184C4.35539 15.1708 4.61684 14.7478 4.92181 14.3567C5.18032 14.0254 5.48093 13.7248 6.08206 13.1236L15.0402 4.16675Z",
    fill: "#7D7D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.7fa822aee183c4adb689ccfdcff4a536.svg";
export { ForwardRef as ReactComponent };